<template>
  <div class="all">
    <iframe v-if="open" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
import Vue from "vue";
import { Image as VanImage, Cascader } from "vant";
Vue.use(VanImage).use(Cascader);
import { mapState, mapMutations } from "vuex";
import { Field } from "vant";
Vue.use(Field);
export default {
  data() {
    return {
      url: "",
      open: true,
    };
  },
  computed: {
    ...mapState(["userInfo", "identity", "houseId"]),
  },
  mounted() {
    var that = this;
    this.url = this.$route.query.url;
    setTimeout(() => {
      this.$axios
        .get(
          "/hyjg/wxzj/jumpPayPage?houseId=" + sessionStorage.getItem("houseId"),
          {}
        )
        .then((res) => {
          if (res.resUrl) {
            that.url = res.resUrl;
          } else {
            this.$toast.fail("无数据");
          }
        });
    }, 1000);
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.all {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
